<template>
  <IvrLayout title="電話自動受付予約（IVR）設定" noIcon :loading="busy">
    <ConfigPage
      :title="type === 'term' ? '期間・日付指定優先度' : '曜日指定優先度'"
      :gap="24"
      scrollable
      showBack
      @back="back"
    >
      <template slot="header">
        <Button @click="back">キャンセル</Button>
        <Button class="is-lead" @click="save" :disabled="!isChanged">保存</Button>
      </template>
      <p>{{ type === 'term' ? '期間・日付指定' : '曜日指定' }}の受付パターンの優先度を変更できます。</p>

      <section>
        <DraggableTable
          v-model="ivrOrders"
          :columns="[
            { key: 'active', name: '設定' },
            { key: 'displayOrder', name: '優先' },
            { key: 'name', name: 'パターン名' },
            { key: 'date', name: type === 'term' ? '期間・日付' : '曜日' },
            { key: 'timeFrame', name: '時間' },
          ]"
          :minItemHeight="58"
        >
          <template #active="{ item }">
            {{ item.active ? '有効' : '無効' }}
          </template>
          <template #date="{ item }">
            {{
              type === 'term'
                ? item.startDate.replace(/-/g, '/') + '〜' + item.endDate.replace(/-/g, '/')
                : weeksText(item)
            }}
          </template>
          <template #timeFrame="{ item }">
            <p v-for="(timeFrame, key) in item.timeFrame" :key="key">
              {{ timeFrame.startTime }}〜{{ timeFrame.endTime }}
            </p>
          </template>
        </DraggableTable>
      </section>
    </ConfigPage>
  </IvrLayout>
</template>

<script>
import { mapState } from 'vuex'
import { isEqual } from 'lodash'
import IvrLayout from '@/components/templates/IvrLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import Button from '@/components/atoms/Button'
import DraggableTable from '@/components/molecules/DraggableTable'

export default {
  name: 'IvrTime',
  components: {
    IvrLayout,
    ConfigPage,
    Button,
    DraggableTable,
  },
  data() {
    return {
      type: this.$route.query.type,
      ivrOrders: [],
    }
  },
  computed: {
    ...mapState({
      ivrTermList: state => state.ivr.list.ivrTermList,
      ivrWeekList: state => state.ivr.list.ivrWeekList,
      busy: state => state.ivr.list.busy,
    }),
    isChanged() {
      return this.ivrOrders && this.type === 'term'
        ? !isEqual(this.ivrOrders, this.ivrTermList.terms)
        : !isEqual(this.ivrOrders, this.ivrWeekList.weeks)
    },
  },
  watch: {
    ivrOrders(val) {
      return [...val.keys()].map(key => (val[key].displayOrder = key + 1))
    },
    isChanged() {
      this.$store.commit('app/editing', this.isChanged)
    },
  },
  async created() {
    await this.fetch(true)
    this.ivrOrders = this.type === 'term' ? this.ivrTermList.terms : this.ivrWeekList.weeks
  },
  methods: {
    async fetch(readonly) {
      const { dispatch } = this.$store
      this.type === 'term'
        ? await dispatch('ivr/list/getTerms', { readonly })
        : await dispatch('ivr/list/getWeeks', { readonly })
      // 優先度順
      this.ivrOrders.sort((a, b) => {
        return a.displayOrder - b.displayOrder
      })
    },
    weeksText(data) {
      const weekObj = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun', 'holiday'].map(week => ({
        weekKey: week,
        label: {
          mon: '月',
          tue: '火',
          wed: '水',
          thu: '木',
          fri: '金',
          sat: '土',
          sun: '日',
          holiday: '祝日',
        }[week],
        weekValue: data[week],
      }))
      return (
        weekObj
          .map(week => week.weekValue && week.label)
          .filter(v => v)
          .join('・') || '未設定'
      )
    },
    async save() {
      this.type === 'term'
        ? await this.$store.dispatch('ivr/edit/saveTerms', { terms: this.ivrOrders })
        : await this.$store.dispatch('ivr/edit/saveWeeks', { weeks: this.ivrOrders })
      this.back()
    },
    back() {
      this.$store.commit('app/editing', false)
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="postcss" scoped>
>>> .active,
>>> .displayOrder {
  justify-content: center;
  min-width: 60px;
  padding: 0;
  width: 60px;
}

>>> .name {
  min-width: 338px;
  white-space: normal;
}

>>> .date {
  justify-content: center;
  min-width: 280px;
  width: 280px;
}

>>> .timeFrame {
  justify-content: center;
  min-width: 140px;
  width: 140px;
}

>>> .draggable-item {
  > .cell {
    padding: 12px 16px;

    &::after {
      height: 100%;
    }
  }

  > .timeFrame {
    flex-flow: column;
  }
}
</style>
